export const zoominfoCheck = {
  methods: {
    zoominfoCheck(fields) { // loops through the fields object to set the values for each.
      fields.forEach((field) => {
        if (this.formdata[field.name]['value'] === '' && (typeof field.value === 'undefined' || field.value === '')) {
          // When the field is not set by ZoomInfo show the field and set the focus
          this.formdata[field.name]['zoominfo']  = false;
          
          if (!this.zoominfoData.meta.focusSet && field.setFocus !== false) { // only sets the focus to the first missed field
            this.setFocus(this.$refs[field.name]);
            this.zoominfoData.meta.focusSet = true;
          }

        } else {
          if (typeof field.value !== 'undefined') { // when a value is specified add it in
            this.formdata[field.name]['value'] = field.value;
          }
          this.zoominfoData.meta.enrich_count++;
          this.zoominfoData.meta.filled_fields.push(field.name); 
        }
      });
    },
  }
}


// WEBPACK FOOTER //
// ./src/components/exports/zoominfo.js